import { render, staticRenderFns } from "./new-supplier.vue?vue&type=template&id=0273619e"
import script from "./new-supplier.vue?vue&type=script&lang=js"
export * from "./new-supplier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports